import * as React from 'react';
import { FC } from 'react';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { InsuranceType } from '@websky/graphql';
import { CdnIcon, Tip } from '@shared/ui';
import { BannerVariant } from './types';
import { buildDataAttributes } from '@shared/lib/dom';

interface Props {
	className?: string;
	variant?: BannerVariant;
	title?: string;
	popular?: boolean;
	code: string;
	type: InsuranceType;
}
export const Banner: FC<Props> = ({ className, title, code, popular, variant = 'icon', type }) => {
	const { t } = useTranslation('InsurancePage');
	const { Banner: theme } = useTheme('InsurancePage');

	return (
		<div
			className={cn(theme.banner, className, { [theme.withTitle]: variant === 'title' })}
			{...buildDataAttributes({
				'insurance-program-code': code,
				'insurance-program-type': type
			})}
		>
			{variant === 'title' ? (
				<>
					{popular && <Tip className={theme.popularBadge} variant="popular" title={t('Most popular')} />}
					<div className={cn(theme.title, { [theme.isPopular]: popular })}>{title}</div>
				</>
			) : (
				<div className={theme.icons}>
					{popular && <Tip className={theme.tip} variant="popular" title={t('Most popular')} />}
					<CdnIcon icon={'Services/Insurance'} />
					<CdnIcon icon={'Payment/Cash'} />
				</div>
			)}
		</div>
	);
};
